import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../../components/ui/card';
import { Users, Eye, AlertTriangle, LogOut, Loader2 } from 'lucide-react';
import { CandidatsListe } from '../../../components/entreprise/CandidatsListe';
import { FicheCandidatEntreprise } from '../../../components/entreprise/FicheCandidatEntreprise';
import { CandidatFicheActions } from '../../../components/candidat/CandidatFicheActions';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cadre « Candidats de l'action » : liste type portail financeur (entreprise, assiduité) + œil / PDF / crayon
export const CandidatsCadre = ({ dossierId, date, refreshKey, titre = "Candidats de l'action", onEdit, editQuery = '?edit=1', flat = false }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    axios.get(`${API_URL}/portail/formateur/action/${dossierId}/candidats-suivi`, { params: date ? { date } : {} }).then(r => setData(r.data)).catch(() => setData({ candidats: [] }));
  }, [dossierId, date, refreshKey]);
  const [fiche, setFiche] = useState(null);
  const open = (cid) => setFiche(cid);
  const edit = (c) => (onEdit ? onEdit(c) : navigate(`/dossiers/${dossierId}/candidat/${c.candidat_id}${editQuery}`));
  const candidats = data?.candidats || [];
  const nbDiff = candidats.filter(c => !c.abandon && (c.en_difficulte || c.nb_alertes_formateur > 0)).length;
  const nbAb = candidats.filter(c => c.abandon).length;
  const Wrapper = flat ? 'div' : Card;
  return (
    <Wrapper className={flat ? '' : 'border-0 shadow-sm overflow-hidden'} data-testid="cadre-candidats">
      <CardContent className="p-0">
        <div className="px-5 py-3 flex items-center justify-between gap-3 flex-wrap bg-slate-50/60 border-b border-slate-100">
          <h2 className="text-sm font-semibold text-slate-800 flex items-center gap-2">
            <Users className="w-4 h-4 text-indigo-600" /> {titre}
            <span className="text-xs font-normal text-slate-400">({candidats.length - nbAb} actif{candidats.length - nbAb > 1 ? 's' : ''}{nbAb ? `, ${nbAb} abandon${nbAb > 1 ? 's' : ''}` : ''})</span>
            {nbDiff > 0 && <span className="text-xs text-red-600 flex items-center gap-1 font-normal"><AlertTriangle className="w-3.5 h-3.5" /> {nbDiff} en difficulté / alerte</span>}
          </h2>
          <p className="text-[11px] text-slate-400 flex items-center gap-1"><Eye className="w-3 h-3" /> Œil : aperçu du candidat · PDF : fiche téléchargeable · Crayon : fiche modifiable</p>
        </div>
        {!data ? <div className="p-6 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-indigo-500" /></div>
          : candidats.length === 0 ? <p className="px-5 py-4 text-xs text-slate-400 italic" data-testid="cadre-candidats-vide">Aucun candidat affecté à cette action.</p>
          : <CandidatsListe candidats={candidats} dossierId={dossierId} onOpen={open} accent="indigo" showEntreprise
              renderActions={(c) => (
                <div className="flex items-center gap-1 shrink-0">
                  <CandidatFicheActions dossierId={dossierId} candidatId={c.candidat_id} nom={c.nom} prenom={c.prenom} onEdit={() => edit(c)} />
                  {c.abandon && <LogOut className="w-4 h-4 text-red-400 ml-1" title="Abandon confirmé" />}
                </div>
              )} />}
      </CardContent>
      <FicheCandidatEntreprise open={!!fiche} candidatId={fiche} dossierId={dossierId} onClose={() => setFiche(null)} apiBase={`${API_URL}/portail/formateur`}
        onEdit={fiche ? () => { const c = candidats.find(x => x.candidat_id === fiche); setFiche(null); edit(c || { candidat_id: fiche }); } : undefined} />
    </Wrapper>
  );
};
